module.exports = __webpack_public_path__ + "static/media/up.db572a9c.PNG";